import Logo from "../../assets/svg/jesoloLogo.svg";
const Navbar = () => {
  return (
    <div className="flex items-center justify-center bg-white h-88px w-full shadow-navbarShadow z-50 fixed pt-3">
      <img src={Logo} alt="Your Jesolo Logo" />
    </div>
  );
};
export default Navbar;
